export enum PreloadMessageSource {
  Host = 'checkout-preload-host',
  Viewer = 'checkout-preload-viewer',
}

export enum PreloadMessageType {
  LoadCart = 'loadCart',
  Ready = 'ready',
}

export type LoadCartMessage = {
  source: PreloadMessageSource.Host;
  type: PreloadMessageType.LoadCart;
  payload: {cartId?: string};
};

export type PreloadReadyMessage = {
  source: PreloadMessageSource.Viewer;
  type: PreloadMessageType.Ready;
};
